import Jump from 'jump.js';

let j = new Jump();
let $ = jQuery;


class BackToTop {

  constructor(context) {

    if (context !== document) {
      return;
    }

    this.displayClass = 'back-to-top--display';

    this.$element = $('.back-to-top');
    this.$element.on('click', () => this.handleClick());

    this.$window = $(window);
    this.$window.on('scroll', () => this.handleScroll());
    this.handleScroll();
  }

  handleClick() {
    var distance = $(document).height();
    j.jump(distance * -1, {
      duration: distance / 5
    });
  }

  handleScroll() {
    if(this.$window.scrollTop() > 0) {
      this.$element.addClass(this.displayClass);
    } else {
      this.$element.removeClass(this.displayClass);
    }
  }

}

module.exports = {
  attach: function (context, settings) {
    let backToTop = new BackToTop(context);
  }
};
